import React from 'react';
import PropTypes from 'prop-types';

class InfoWidget extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section className={`panel panel-featured-left panel-featured-${this.props.bsStyle || 'primary'}`}>
        <div className="panel-body">
          <div className="widget-summary widget-summary-sm">
            <div className="widget-summary-col widget-summary-col-icon">
              <div className={`summary-icon bg-${this.props.bsStyle || 'primary'} ${this.props.iconBgColor}`}>
                <i className={this.props.icon}></i>
              </div>
            </div>
            <div className="widget-summary-col">
              <div className="summary">
                <h4 className="title">{this.props.title || ''}</h4>
                <div className="info">
                  <strong className="amount">{this.props.text || ''}</strong>
                  <span className="text-primary">{this.props.extra || ''}</span>
                </div>
              </div>
              <div className="summary-footer">
                <a className="text-muted text-uppercase">(view all)</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

InfoWidget.propTypes = {
  title : PropTypes.string,
  extra: PropTypes.string,
  text: PropTypes.string,
  bsStyle : PropTypes.string,
}

export default InfoWidget;



// WEBPACK FOOTER //
// ./src/browser/components/ui/infoWidget.js